import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const SecDashIcon = () => {
  return (
    <SvgIcon>
      <svg fill="none">
        <path
          d="M1.30765 4.36469C0.955254 4.38982 0.749315 4.65415 0.75 4.88215C0.761671 8.76537 0.891298 12.1789 2.13044 15.2076C3.35172 18.1927 5.68682 20.8791 10.2815 23.1996C10.4147 23.2668 10.5853 23.2668 10.7185 23.1996C15.3132 20.8791 17.6483 18.1927 18.8696 15.2076C20.1087 12.1789 20.2383 8.76537 20.25 4.88215C20.2507 4.65415 20.0447 4.38982 19.6923 4.36469C15.6328 4.07521 13.0458 2.46799 11.5431 1.07076L12.0537 0.521496L11.543 1.07076C11.352 0.893165 10.9708 0.750001 10.5 0.75C10.0292 0.749999 9.64798 0.893162 9.45697 1.07076C7.95419 2.46799 5.36717 4.07521 1.30765 4.36469Z"
          stroke="#B5B5B5"
          strokeWidth="1.5"
        />
        <rect
          width="3"
          height="6"
          rx="0.560801"
          transform="matrix(-1 0 0 1 8 8)"
          fill="#B5B5B5"
        />
        <rect
          width="3.07551"
          height="8"
          rx="0.560801"
          transform="matrix(-1 0 0 1 12.0381 6)"
          fill="#B5B5B5"
        />
        <rect
          width="3"
          height="5"
          rx="0.560801"
          transform="matrix(-1 0 0 1 16 9)"
          fill="#B5B5B5"
        />
      </svg>
    </SvgIcon>
  );
};
